var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echart",attrs:{"id":"myEcharts2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }